module.exports = __webpack_public_path__ + "static/media/zf_3.35fed027.png";